// pages/DocPages.jsx — halaman-halaman grup DOCS (masing-masing satu menu di sidebar).
// DMS Project = komponen React (data live AWS). MR Report & Atmosfer = konten dinamis
// dari backend/docs/<key>.html lewat DynamicDoc — ubah isinya tanpa build frontend.
import React from 'react';
import DmsProject from './DmsProject';
import DynamicDoc from './DynamicDoc';
import SAPProcessMap from './SAPProcessMap'; // pindah dari SAP Configuration (04-11-2026)

function Shell({ title, sub, children }) {
  return (
    <div className="space-y-4 p-4">
      <div>
        <h1 className="text-xl font-semibold text-gray-900">{title}</h1>
        {sub && <p className="text-sm text-gray-500">{sub}</p>}
      </div>
      {children}
    </div>
  );
}

export function DocDms() {
  return <Shell title="DMS Project" sub="dms.pgocid.com architecture and request flow, with live AWS status."><DmsProject /></Shell>;
}

export function DocMrReport() {
  return <Shell title="MR Report" sub="Management Reports: data flow from SAP ECC to the five report areas."><DynamicDoc docKey="mr-report" /></Shell>;
}

export function DocAtmosfer() {
  return <Shell title="Atmosfer" sub="Customs documents (BC) for oil PO/SO and weighbridge matching."><DynamicDoc docKey="atmosfer" /></Shell>;
}

export function DocProcessMap() {
  return <Shell title="SAP Process Map" sub="Business process map of P01 ID, JB and KL — document types, volumes and custom points per step."><SAPProcessMap /></Shell>;
}
